import app from 'flarum/forum/app';
export default function loadPublications(type) {
  // Параметр кодируется штатным URLSearchParams, чтобы тип публикации не мог изменить структуру URL.
  const query = new URLSearchParams();
  if (type) {
    query.set('type', type);
  }
  return app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/devconnect/publications?${query.toString()}`
  });
}
flarum.reg.add('devconnect-articles', 'forum/service/publicationApi', loadPublications);